import { render, staticRenderFns } from "./toolbar-input.vue?vue&type=template&id=12e6ffa7&scoped=true&"
import script from "./toolbar-input.vue?vue&type=script&lang=ts&"
export * from "./toolbar-input.vue?vue&type=script&lang=ts&"
import style0 from "./toolbar-input.vue?vue&type=style&index=0&id=12e6ffa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e6ffa7",
  null
  
)

export default component.exports